var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Qualification question asking whether the property is a seasonal rental, with a yes/no answer.
 * touches: water damage qualification UX
 * invariants: help link is hidden only when the insurer feature flag and the self-care setting both disable it
 * inputs: isSeasonalRental yes/no answer
 * outputs: updates and saves the qualification through the qualification store
 * see: frontend/src/declaration/components/UI/QuestionPanel.vue, frontend/src/shared/types/api/claim.ts
 */
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let IsSeasonalRentalQuestion = class IsSeasonalRentalQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    updateClaim(isSeasonalRental) {
        this.updateAndSaveQualification({
            qualificationPayload: {
                isSeasonalRental,
                ...(isSeasonalRental
                    ? {
                        isPremiseFurnished: null,
                        isLeaveBeforeSinister: null,
                    }
                    : {}),
            },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.seasonal-rental.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.seasonal-rental.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.isSeasonalRental === null) {
            return null;
        }
        return this.qualification.isSeasonalRental
            ? this.$tc('claim.qualification.seasonal-rental.sumup.yes')
            : this.$tc('claim.qualification.seasonal-rental.sumup.no');
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.isSeasonalRental) === null || _d === void 0 ? void 0 : _d.showHelpLink) !== false;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], IsSeasonalRentalQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], IsSeasonalRentalQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], IsSeasonalRentalQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    settings.Getter('setting')
], IsSeasonalRentalQuestion.prototype, "setting", void 0);
IsSeasonalRentalQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], IsSeasonalRentalQuestion);
export default IsSeasonalRentalQuestion;
